import logService from '../../../services/wss/logService3';
import EngineCleanupBase from '../../../services/engines/EngineCleanupBase';
import gatewayService from '../../../services/GatewayService';
import userTypeCache from './UserTypeCache';

const _name = 'UserTypeEngine';

/**
 * Loads the distinct entry types the user has created across their journals
 * (via gatewayService.getUserTypes()). Replaces the static ENTRY_TYPES list
 * used in JInspector's Type dropdown.
 * Fetched once at bootup — no socket push, call refresh() manually if a
 * brand-new type was just created and needs to show up immediately.
 */
class UserTypeEngine extends EngineCleanupBase {
    bootup = async () => {
        try {
            this.initialize(_name);
        } catch (error) {
            logService.logError(`${_name}.bootup: error=${error.message}`);
        }
    };

    /**
     * Re-fetches user types from BE and replaces cache.
     */
    fetch = async () => {
        try {
            const res = await gatewayService.getUserTypes();
            userTypeCache.setItems(res?.data.items ?? []);
        } catch (error) {
            this.logError('fetc', error.message);
        }
    };

    /**
     * Returns cached types mapped to dropdown format.
     * Sorted alphabetically by label.
     * @returns {{label: string, value: string}[]}
     */
    getDropdownItems = () => {
        try {
            const items = userTypeCache.getItems();
            return items;
        } catch (error) {
            this.logError('getDropdownItems', error.message);
            return [];
        }

        // return [...userTypeCache.getItems()].sort((a, b) => a.label.localeCompare(b.label));
    };
}

const userTypeEngine = new UserTypeEngine();
export default userTypeEngine;
